/**
 * bulk-add-to-cart.js
 * ------------------------------------------------------------
 * Junta en una sola peticion: cantidades de "Entrega inmediata"
 * (stock directo) y de "Sobre pedido" (independiente del stock).
 * Usa el popup nativo de Shopify (cart-notification) igual que
 * cuando se agrega cualquier otro producto normal, Y ADEMAS
 * muestra un aviso propio junto a la insignia de precio que
 * desaparece solo despues de 5 segundos.
 *
 * NOTA: el aviso se inserta junto a .color-price-badge (nuestra
 * insignia propia de color+precio), NO junto al precio nativo de
 * Dawn ([id^="price-"]) -- ese elemento nativo esta oculto via CSS
 * desde que existe la insignia, asi que insertar el aviso ahi lo
 * dejaba invisible.
 *
 * Despues de agregar, todas las cantidades vuelven a 0 para
 * evitar que un doble clic duplique la cantidad.
 * ------------------------------------------------------------
 */
(function () {
  if (window.__bulkAddToCartInit) return;
  window.__bulkAddToCartInit = true;

  function collectItems(table) {
    var items = [];
    var inputsToReset = [];

    table.querySelectorAll('[data-vit-qty-input]').forEach(function (input) {
      var qty = parseInt(input.value, 10) || 0;
      var variantId = input.dataset.variantId;
      if (qty > 0 && variantId) {
        items.push({
          id: parseInt(variantId, 10),
          quantity: qty,
          properties: { Tipo: 'Stock directo' }
        });
        inputsToReset.push(input);
      }
    });

    table.querySelectorAll('[data-vit-order-input]').forEach(function (input) {
      var qty = parseInt(input.value, 10) || 0;
      var variantId = input.dataset.variantId;
      if (qty > 0 && variantId) {
        items.push({
          id: parseInt(variantId, 10),
          quantity: qty,
          properties: { Tipo: 'Bajo pedido (proveedor)' }
        });
        inputsToReset.push(input);
      }
    });

    return { items: items, inputsToReset: inputsToReset };
  }

  function showConfirmationNextToPrice(productInfo, message) {
    var existing = document.getElementById('bulk-add-confirmation');
    if (existing) existing.remove();

    var priceEl =
      productInfo.querySelector('.color-price-badge__price') || productInfo.querySelector('[id^="price-"]');

    var note = document.createElement('p');
    note.id = 'bulk-add-confirmation';
    note.setAttribute('role', 'status');
    note.style.cssText =
      'display:inline-block;margin:0.6rem 0 0;padding:0.5rem 1rem;border-radius:8px;' +
      'background:rgba(62,154,96,0.12);color:rgb(40,120,70);font-size:1.3rem;';
    note.textContent = message;

    if (priceEl) {
      priceEl.insertAdjacentElement('afterend', note);
    } else {
      productInfo.insertBefore(note, productInfo.firstChild);
    }

    setTimeout(function () {
      if (note.parentElement) note.remove();
    }, 5000);
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;

      var productInfo = form.closest('product-info') || document;
      var table = productInfo.querySelector('[data-variant-inventory-table]');
      if (!table) return;

      var collected = collectItems(table);
      if (collected.items.length === 0) return; // nada especificado: comportamiento normal

      event.preventDefault();
      event.stopImmediatePropagation();

      var button = form.querySelector('button[type="submit"]');
      var originalText = button ? button.innerHTML : '';
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      }

      var totalQty = collected.items.reduce(function (sum, item) {
        return sum + item.quantity;
      }, 0);

      var cartNotification = document.querySelector('cart-notification');
      var payload = { items: collected.items };
      if (cartNotification) {
        payload.sections = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
        payload.sections_url = window.location.pathname;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error(data.description || 'No se pudo agregar al carrito');
            });
          }
          return response.json();
        })
        .then(function (result) {
          // Regresa todas las cantidades a 0 para evitar duplicados por doble clic
          collected.inputsToReset.forEach(function (input) {
            input.value = 0;
          });

          if (button) {
            button.disabled = false;
            button.removeAttribute('aria-busy');
            button.innerHTML = originalText;
          }

          if (cartNotification && result.items && result.items.length && result.sections) {
            var lastItem = result.items[result.items.length - 1];
            cartNotification.renderContents({ key: lastItem.key, sections: result.sections });
          }

          showConfirmationNextToPrice(productInfo, totalQty + ' pieza(s) agregada(s) al carrito correctamente.');

          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(function (error) {
          console.error('bulk-add-to-cart error:', error);
          if (button) {
            button.disabled = false;
            button.removeAttribute('aria-busy');
            button.innerHTML = originalText;
          }
          alert(
            error && error.message
              ? error.message
              : 'No se pudo agregar al carrito. Verifica las cantidades e intenta de nuevo.'
          );
        });
    },
    true
  );
})();
